
import { Vue, Component } from 'vue-property-decorator';
import VoteList from '../components/VoteList.vue';
@Component({
  components: {
    VoteList,
  },
})
export default class Home extends Vue {
  tabs = [
    {
      id: 1,
      text: '重庆奖项参评人',
    },
    {
      id: 2,
      text: '两江新区奖项参评人',
    },
  ];
  activeIndex = 0;
  listType = 1;
  changeTab(index: number) {
    this.activeIndex = index;
    this.listType = index + 1;
  }
}
